import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { authFB, storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import {
    REQUEST_PRODUCT,
    REQUEST_SUPPLIER,
    REQUEST_DELIVERY_ORDER,
    REQUEST_UNIT_HEALTH,
    REQUEST_TICKET,
    REQUEST_SERIAL,
    REQUEST_REQ_TYPE,
    REQUEST_PRIORITY,
    REQUEST_DOCUMENT_TYPE,
    REQUEST_STATUS,
    REQUEST_LIST,
    REQUEST_DETAIL,
    REQUEST_EDIT,
    REQUEST_UPLOAD_SET

} from '../../actions';
import {
    RequestProductSuccess,
    RequestProductError,
    RequestSupplierSuccess,
    RequestSupplierError,
    RequestDeliveryOrderSuccess,
    RequestDeliveryOrderError,
    RequestUnitHealthSuccess,
    RequestUnitHealthError,
    RequestTicketSuccess,
    RequestTicketError,
    RequestSerialSuccess,
    RequestSerialError,
    RequestReqTypeSuccess,
    RequestReqTypeError,
    RequestPrioritySuccess,
    RequestPriorityError,
    RequestDocumentTypeSuccess,
    RequestDocumentTypeError,
    RequestStatusSuccess,
    RequestStatusError,
    RequestListSuccess,
    RequestListError,
    RequestDetailSuccess,
    RequestDetailError,
    RequestEditSuccess,
    RequestEditError,
    RequestUploadSetSuccess,
    RequestUploadSetError
} from '../../actions';

export function* watchRequestProduct() {
    yield takeEvery(REQUEST_PRODUCT, onRequestProduct);
}

export function* watchRequestSupplier() {
    yield takeEvery(REQUEST_SUPPLIER, onRequestSupplier);
}

export function* watchRequestDeliveryOrder() {
    yield takeEvery(REQUEST_DELIVERY_ORDER, onRequestDeliveryOrder);
}

export function* watchRequestUnitHealth() {
    yield takeEvery(REQUEST_UNIT_HEALTH, onRequestUnitHealth);
}

export function* watchRequestTicket() {
    yield takeEvery(REQUEST_TICKET, onRequestTicket);
}

export function* watchRequestSerial() {
    yield takeEvery(REQUEST_SERIAL, onRequestSerial);
}

export function* watchRequestReqType() {
    yield takeEvery(REQUEST_REQ_TYPE, onRequestReqType);
}

export function* watchRequestPriority() {
    yield takeEvery(REQUEST_PRIORITY, onRequestPriority);
}

export function* watchRequestDocumentType() {
    yield takeEvery(REQUEST_DOCUMENT_TYPE, onRequestDocumentType);
}

export function* watchRequestStatus() {
    yield takeEvery(REQUEST_STATUS, onRequestStatus);
}

export function* watchRequestList() {
    yield takeEvery(REQUEST_LIST, onRequestList);
}

export function* watchRequestDetail() {
    yield takeEvery(REQUEST_DETAIL, onRequestDetail);
}

export function* watchRequestEdit() {
    yield takeEvery(REQUEST_EDIT, onRequestEdit);
}

export function* watchRequestUploadSet() {
    yield takeEvery(REQUEST_UPLOAD_SET, onRequestUploadSet);
}
function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}


const onRequestProductAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/product', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRequestSupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRequestDeliveryOrderAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/deliveryorder', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRequestUnitHealthAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/unithealth', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRequestTicketAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/ticket', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRequestSerialAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/serial', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRequestReqTypeAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/requesttype', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRequestPriorityAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/priority', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRequestDocumentTypeAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/typedocumentsupport', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRequestStatusAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/statusrequest', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRequestListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRequestDetailAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/detail', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onRequestEditAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'request/edit', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


const onRequestUploadSetAsync = async (file) => {
    var storageRef = storage.ref();
    let filename = file.name;
    return await new Promise((success, reject) => {
        var uploadTask = storageRef.child(storagePath + '/reqService/' + filename).put(file);
        uploadTask.on('state_changed',
            function (snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
            function (error) {
                reject({ name: filename, original: file.name, message: error.code, url: '', type: file.type, size: file.size, path: 'tickets/' })
            },
            function () {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    success({ message: 'success', name: filename, original: file.name, url: downloadURL });
                });
            });
    });
};

function* onRequestProduct(data) {
    try {
        const response = yield call(onRequestProductAsync, data.payload);
        yield put(RequestProductSuccess(response.data));
    } catch (error) {
        yield put(RequestProductError(error));
    }
}

function* onRequestSupplier(data) {
    try {
        const response = yield call(onRequestSupplierAsync, data.payload);
        yield put(RequestSupplierSuccess(response.data));
    } catch (error) {
        yield put(RequestSupplierError(error));
    }
}

function* onRequestDeliveryOrder(data) {
    try {
        const response = yield call(onRequestDeliveryOrderAsync, data.payload);
        yield put(RequestDeliveryOrderSuccess(response.data));
    } catch (error) {
        yield put(RequestDeliveryOrderError(error));
    }
}

function* onRequestUnitHealth(data) {
    try {
        const response = yield call(onRequestUnitHealthAsync, data.payload);
        yield put(RequestUnitHealthSuccess(response.data));
    } catch (error) {
        yield put(RequestUnitHealthError(error));
    }
}

function* onRequestTicket(data) {
    try {
        const response = yield call(onRequestTicketAsync, data.payload);
        yield put(RequestTicketSuccess(response.data));
    } catch (error) {
        yield put(RequestTicketError(error));
    }
}

function* onRequestSerial(data) {
    try {
        const response = yield call(onRequestSerialAsync, data.payload);
        yield put(RequestSerialSuccess(response.data));
    } catch (error) {
        yield put(RequestSerialError(error));
    }
}

function* onRequestReqType(data) {
    try {
        const response = yield call(onRequestReqTypeAsync, data.payload);
        yield put(RequestReqTypeSuccess(response.data));
    } catch (error) {
        yield put(RequestReqTypeError(error));
    }
}

function* onRequestPriority(data) {
    try {
        const response = yield call(onRequestPriorityAsync, data.payload);
        yield put(RequestPrioritySuccess(response.data));
    } catch (error) {
        yield put(RequestPriorityError(error));
    }
}

function* onRequestDocumentType(data) {
    try {
        const response = yield call(onRequestDocumentTypeAsync, data.payload);
        yield put(RequestDocumentTypeSuccess(response.data));
    } catch (error) {
        yield put(RequestDocumentTypeError(error));
    }
}

function* onRequestStatus(data) {
    try {
        const response = yield call(onRequestStatusAsync, data.payload);
        yield put(RequestStatusSuccess(response.data));
    } catch (error) {
        yield put(RequestStatusError(error));
    }
}

function* onRequestList(data) {
    try {
        const response = yield call(onRequestListAsync, data.payload);
        yield put(RequestListSuccess(response.data));
    } catch (error) {
        yield put(RequestListError(error));
    }
}

function* onRequestDetail(data) {
    try {
        const response = yield call(onRequestDetailAsync, data.payload);
        yield put(RequestDetailSuccess(response.data));
    } catch (error) {
        yield put(RequestDetailError(error));
    }
}

function* onRequestEdit(data) {
    try {
        const response = yield call(onRequestEditAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(RequestEditSuccess(response.data));
    } catch (error) {
        yield put(RequestEditError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onRequestUploadSet({ payload }) {
    const { file } = payload;
    try {
        const response = yield call(onRequestUploadSetAsync, file);
        console.log("response" + JSON.stringify(response));
        if (response.message === 'success') {

            yield put(RequestUploadSetSuccess(response));

        }
        else {
            yield put(RequestUploadSetError(response));
        }
    } catch (error) {
        yield put(RequestUploadSetError({ name: '', original: file.name, message: error, url: '', path: '' }))
    }
}


export default function* rootSaga() {
    yield all([
        fork(watchRequestProduct),
        fork(watchRequestSupplier),
        fork(watchRequestDeliveryOrder),
        fork(watchRequestUnitHealth),
        fork(watchRequestTicket),
        fork(watchRequestSerial),
        fork(watchRequestReqType),
        fork(watchRequestPriority),
        fork(watchRequestDocumentType),
        fork(watchRequestStatus),
        fork(watchRequestList),
        fork(watchRequestDetail),
        fork(watchRequestEdit),
        fork(watchRequestUploadSet)
    ]);
}